Bingo.OfferStatistics = {};

Bingo.OfferStatistics.incrementPhoneDisplayed = ($offerId) => {
    jQuery.ajax({
        url: '/api/v1/offer-statistics/increment-phone-displayed-by-offer-id',
        data: {
            offerId: $offerId,
        },
    });
};

Bingo.OfferStatistics.incrementPhoneClicked = ($offerId) => {
    jQuery.ajax({
        url: '/api/v1/offer-statistics/increment-phone-clicked-by-offer-id',
        data: {
            offerId: $offerId,
        },
    });
};
